<ui-grid-row>
	<div class="bg-white shadow w-20r scrollable p-2">
		<table class="table table-hover no-border nav-table table-sm">
			<tbody>
				<tr>
					<td class="selectable l1 h3" (click)="scrollTo('navtarget-top')">WeQuote API</td>
				</tr>
				<tr>
					<td class="selectable l2 h4" (click)="scrollTo('navtarget-auth')">Authentication</td>
				</tr>
				<tr>
					<td class="selectable l2 h4" (click)="scrollTo('navtarget-webhook-management')">Webhook Management</td>
				</tr>
				<tr>
					<td class="selectable l3" (click)="scrollTo('navtarget-webhook-list')">List Webhooks</td>
				</tr>
				<tr>
					<td class="selectable l3" (click)="scrollTo('navtarget-webhook-info')">Webhook Delivery Info</td>
				</tr>
				<tr>
					<td class="selectable l3" (click)="scrollTo('navtarget-webhook-delivery')">Delivery &amp; Retries</td>
				</tr>
				<ng-container *ngFor="let t of types">
					<tr>
						<td class="selectable l2 h4" (click)="scrollTo('navtarget-type-' + t.id)">{{t.menu}}</td>
					</tr>
					<ng-container *ngFor="let item of list; index as index">
						<ng-container *ngIf="item.type === t.id">
							<tr>
								<td class="selectable l3" (click)="scrollTo('navtarget-' + index)">{{item.display?.label || item.key}}</td>
							</tr>
						</ng-container>
					</ng-container>
				</ng-container>
			</tbody>
		</table>
	</div>

	<div class="d-flex flex-column fill scrollable">
		<div class="container my-5" *ngIf="data">
			<h1 class="mb-4 navtarget-top">API Developer Documentation</h1>
			<p class="lead">This documentation describes how to integrate directly with the WeQuote API.</p>
			<div class="card shadow-sm mb-5">
				<div class="card-header">
					<h3 class="mb-0 navtarget-auth">Authentication</h3>
				</div>

				<div class="card-body">
					<p>All API requests must include your API key either by adding the <code>Api-Key</code> request header, or the <code>api_key</code> query parameter directly to the URL.</p>
					<pre class="bg-dark text-light p-3 rounded">
Request headers:

Api-Key: YOUR_API_KEY
Content-Type: application/json
Accept: application/json
</pre>
				</div>
			</div>


			<h2 class="mb-4 navtarget-webhook-management">Webhook Management</h2>

			<!-- List Webhooks -->
			<div class="card shadow-sm mb-5 navtarget-webhook-list">
				<div class="card-header">
					<h3 class="mb-0">List Webhooks</h3>
				</div>
				<div class="card-body">
					<p>Returns every webhook currently registered for your organisation. Optionally filter to a single event type with the <code>type</code> query parameter.</p>

					<h5 class="text-success">Request Endpoint</h5>
					<pre class="bg-dark text-light p-3 rounded">
GET {{origin}}/external/webhook/list
GET {{origin}}/external/webhook/list?type=quote_status_changed
</pre>

					<h5 class="text-success">Request Input Fields</h5>
					<table class="table table-bordered table-sm">
						<thead class="thead-light">
							<tr>
								<th>Field</th>
								<th>Label</th>
								<th>Type</th>
								<th>Required</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>type</td>
								<td>Event Type</td>
								<td>string</td>
								<td>No</td>
							</tr>
						</tbody>
					</table>

					<h5 class="text-info">Response</h5>
					<pre class="bg-dark text-light p-3 rounded">{{webhookListSample | json}}</pre>

					<h5 class="text-info">Response Output Fields</h5>
					<table class="table table-sm table-bordered">
						<thead class="thead-light">
							<tr>
								<th>Field</th>
								<th>Label</th>
								<th>Type</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>id</td>
								<td>Webhook ID</td>
								<td>integer</td>
							</tr>
							<tr>
								<td>event_type</td>
								<td>Event Type</td>
								<td>string</td>
							</tr>
							<tr>
								<td>hook_url</td>
								<td>Target URL</td>
								<td>string</td>
							</tr>
							<tr>
								<td>created_datetime</td>
								<td>Registered On</td>
								<td>string</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>

			<!-- Webhook Delivery Info -->
			<div class="card shadow-sm mb-5 navtarget-webhook-info">
				<div class="card-header">
					<h3 class="mb-0">Webhook Delivery Info</h3>
				</div>
				<div class="card-body">
					<p>Returns a delivery health snapshot for your organisation's webhooks: the total number of queued (pending) and failed events, how many hooks are currently throttled, and a per-hook breakdown of the same figures along with each hook's throttling status.</p>

					<h5 class="text-success">Request Endpoint</h5>
					<pre class="bg-dark text-light p-3 rounded">
GET {{origin}}/external/webhook/info
</pre>

					<h5 class="text-info">Response</h5>
					<pre class="bg-dark text-light p-3 rounded">{{webhookInfoSample | json}}</pre>

					<h5 class="text-info">Response Output Fields</h5>
					<table class="table table-sm table-bordered">
						<thead class="thead-light">
							<tr>
								<th>Field</th>
								<th>Label</th>
								<th>Type</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>webhook_count</td>
								<td>Total registered webhooks</td>
								<td>integer</td>
							</tr>
							<tr>
								<td>throttled_count</td>
								<td>Webhooks currently throttled</td>
								<td>integer</td>
							</tr>
							<tr>
								<td>queued_events</td>
								<td>Events awaiting delivery</td>
								<td>integer</td>
							</tr>
							<tr>
								<td>failed_events</td>
								<td>Events in permanent failure</td>
								<td>integer</td>
							</tr>
							<tr>
								<td>webhooks[].throttled</td>
								<td>Whether the hook is currently throttled</td>
								<td>boolean</td>
							</tr>
							<tr>
								<td>webhooks[].throttled_until</td>
								<td>Throttled until (null if active)</td>
								<td>string</td>
							</tr>
							<tr>
								<td>webhooks[].consecutive_failures</td>
								<td>Consecutive delivery failures</td>
								<td>integer</td>
							</tr>
							<tr>
								<td>webhooks[].queued_events</td>
								<td>Events awaiting delivery for this hook</td>
								<td>integer</td>
							</tr>
							<tr>
								<td>webhooks[].failed_events</td>
								<td>Permanently failed events for this hook</td>
								<td>integer</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>

			<!-- Delivery & Retries -->
			<div class="card shadow-sm mb-5 navtarget-webhook-delivery">
				<div class="card-header">
					<h3 class="mb-0">Delivery &amp; Retries</h3>
				</div>
				<div class="card-body">
					<p>The following rules govern how webhook events are delivered once an event is queued.</p>
					<ul>
						<li><strong>URL validation.</strong> When registering a webhook, the target URL must be a public <code>http</code> or <code>https</code> address. URLs pointing at <code>localhost</code>, loopback, or private/reserved IP ranges (e.g. <code>127.0.0.1</code>, <code>10.x</code>, <code>192.168.x</code>, <code>169.254.x</code>) are rejected with an <code>Invalid webhook URL</code> error.</li>
						<li><strong>Timeout.</strong> Each delivery attempt is given up to 10 seconds to complete before it is treated as a failure.</li>
						<li><strong>Retries.</strong> A failed event is retried with an increasing backoff. After 3 failed attempts it is marked as permanently failed and is no longer retried; it then counts towards <code>failed_events</code> in the delivery info.</li>
						<li><strong>Throttling.</strong> A webhook that fails repeatedly is throttled: once it reaches 3 consecutive failures, delivery of its events is paused for a progressively longer period (up to one hour). A single successful delivery clears the throttle. Throttled hooks are reported by <code>throttled</code> / <code>throttled_until</code> in the delivery info.</li>
						<li><strong>Success.</strong> A webhook endpoint must respond with HTTP <code>200</code> for delivery to be considered successful. Any other status code (or a connection/timeout error) counts as a failure.</li>
					</ul>
				</div>
			</div>


			<div *ngFor="let t of types">
				<h2 class="mb-4 navtarget-type-{{t.id}}">{{t.menu}}</h2>

				<ng-container *ngFor="let item of list; index as index">
					<ng-container *ngIf="item.type === t.id">
						<div class="card shadow-sm mb-5 navtarget-{{index}}">
							<div class="card-header">
								<h3 class="mb-0">{{item.display?.label || item.key}}</h3>
							</div>
							<div class="card-body">

								<p *ngIf="item.display?.description">{{item.display.description}}</p>

								<!-- Subscribe -->
								<div *ngIf="item.operation?.performSubscribe">
									<h5 class="text-success">Subscribe Endpoint</h5>
									<pre class="bg-dark text-light p-3 rounded">
POST {{item.operation.performSubscribe.url}}

{{item.operation.performSubscribe.body | json}}
</pre>
								</div>

								<div *ngIf="item.operation?.performSubscribe">
									<h5 class="text-success">Subscribe Response</h5>
									<pre class="bg-dark text-light p-3 rounded">
{{({ id: 'WEBHOOK_ID' }) | json}}
</pre>
								</div>

								<!-- Unsubscribe -->
								<div *ngIf="item.operation?.performUnsubscribe">
									<h5 class="text-danger">Unsubscribe Endpoint</h5>
									<pre class="bg-dark text-light p-3 rounded">
POST {{item.operation.performUnsubscribe.url}}

{{item.operation.performUnsubscribe.body | json}}
</pre>
								</div>

								<!-- Endpoint -->
								<div *ngIf="item.operation?.perform && item.operation.perform.url">
									<h5 class="text-success">Request Endpoint</h5>
									<pre class="bg-dark text-light p-3 rounded">
{{item.operation.perform.method || 'GET'}} {{item.operation.perform.url}}
</pre>
								</div>

								<!-- Inputs -->
								<div *ngIf="item.operation?.inputFields?.length">
									<h5 class="text-success">Request Input Fields</h5>
									<table class="table table-bordered table-sm">
										<thead class="thead-light">
											<tr>
												<th>Field</th>
												<th>Label</th>
												<th>Type</th>
												<th>Required</th>
											</tr>
										</thead>
										<tbody>
											<tr *ngFor="let field of item.operation.inputFields" [ngClass]="{ 'text-bold': field.required }">
												<td>{{field.key}}</td>
												<td>{{field.label}}</td>
												<td>{{field.type}}</td>
												<td>{{field.required ? 'Yes' : 'No'}}</td>
											</tr>
										</tbody>
									</table>
								</div>

								<!-- Sample -->
								<div *ngIf="item.operation?.sample">
									<h5 *ngIf="item.type === 'webhook'" class="text-info">Sample Payload</h5>
									<h5 *ngIf="item.type !== 'webhook'" class="text-info">Response</h5>
									<pre class="bg-dark text-light p-3 rounded">{{item.operation.sample | json}}</pre>
								</div>

								<!-- Output Fields -->
								<div *ngIf="item.operation?.outputFields?.length">
									<h5 *ngIf="item.type === 'webhook'" class="text-info">Payload Fields</h5>
									<h5 *ngIf="item.type !== 'webhook'" class="text-info">Response Output Fields</h5>
									<table class="table table-sm table-bordered">
										<thead class="thead-light">
											<tr>
												<th>Field</th>
												<th>Label</th>
												<th>Type</th>
											</tr>
										</thead>
										<tbody>
											<tr *ngFor="let field of item.operation.outputFields">
												<td>{{field.key}}</td>
												<td>{{field.label}}</td>
												<td>{{field.type}}</td>
											</tr>
										</tbody>
									</table>
								</div>

							</div>
						</div>
					</ng-container>
				</ng-container>
			</div>

		</div>

	</div>
</ui-grid-row>
